export const TOTAL_LOANS = `סה״כ יתרת הלוואות`
export const DATE_CTA =  `הנתונים המוצגים באזור האישי נכונים לתאריך: `

export const NO_CONTENT_TITLE = `אנחנו יודעים שעדיין ריק פה...`
export const NO_CONTENT_TEXT = `אל דאגה, נתוני המשכנתא שלך יופיעו לאחר\nביצוע ההלוואה`
